import { webComponentBaseClass } from "/third_party/web-component-base-class/dist/webComponentBaseClass.js";

const customElementName = "home-content";
window.customElements.define(customElementName, class extends webComponentBaseClass {
	static get is() { return customElementName; }

	constructor() { super(); }

	static get template() {
		return `
		<style>
			vicowa-image-container {
				padding: 0;
				position: relative;
				height: 100%;
				margin: 0 1em 0 0;
			}
	
			vicowa-image-container:last-child {
				margin-right: 0;
			}
	
		.images {
				margin-top: 1em;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				height: 350px;
			}
	
			h2 {
				margin: 1.5em 0;
			}
	
		.placeholder {
				color: grey;
				font-style: italic;
			}
	
		</style>
			<div class="section">
				<div class="images">
				<vicowa-image-container alternates='["/resources/images/davinci/davinciportret1.webp", "/resources/images/davinci/davinciportret1.png"]' alt="davinci self portrait" style="width: 17.4%; margin-top: 2em;"></vicowa-image-container>
				<vicowa-image-container alternates='["/resources/images/davinci/davinciportret2.webp", "/resources/images/davinci/davinciportret2.png"]' alt="davinci self portrait old"  style="width: 14.45%; margin-top: 1em;"></vicowa-image-container>
				<vicowa-image-container alternates='["/resources/images/davinci/helicopter.webp", "/resources/images/davinci/helicopter.png"]' alt="davinci helicopter" style="width: 31%;"></vicowa-image-container>
				<vicowa-image-container alternates='["/resources/images/davinci/man.webp", "/resources/images/davinci/man.png"]' alt="davinci man" style="width: 16%; margin-top: 1em;"></vicowa-image-container>
				<vicowa-image-container alternates='["/resources/images/davinci/monalisa_001.webp", "/resources/images/davinci/monalisa.png"]' alt="davinci mona lisa" style="width: 15.2%; margin-top: 2em;"></vicowa-image-container>
				</div>
				<h2><vicowa-string>Why da Vinci?</vicowa-string></h2>
			<div><vicowa-string>Leonardo da Vinci was a man of many talents</vicowa-string>
			</div>
			</div>
		`;
	}
});

// <page-info>
// 	{
// 	"title": "Home",
// 	"displayTitle": "da Vinci Space",
// 	"shortDescription": "da Vinci Space landing page",
// 	"navigationRoot" : "content/Content",
// 	"order": 1
// 	}
// </page-info>
